var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 201.142857l0 621.714286q0 23.990857-22.308571 33.718857-7.460571 2.852571-14.262857 2.852571-15.433143 0-25.746286-10.825143l-230.253714-230.253714 0 94.866286q0 68.022857-48.274286 116.297143t-116.297143 48.274286l-402.285714 0q-68.022857 0-116.297143-48.274286t-48.274286-116.297143l0-402.285714q0-68.022857 48.274286-116.297143t116.297143-48.274286l402.285714 0q68.022857 0 116.297143 48.274286t48.274286 116.297143l0 94.281143 230.253714-229.741714q10.313143-10.825143 25.746286-10.825143 6.875429 0 14.262857 2.852571 22.308571 9.728 22.308571 33.718857z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.504ad036d99a696ab214f74e447765cc.svg";
export { ForwardRef as ReactComponent };